<template>
  <div
    v-if="toggle"
    class="c-timer-inline br--small px-3 py-2 w-medium fs-14 d-flex align-items-start"
    :class="{'c-timer-inline--alert' : (time.h <= 1)}"
  >
    <div class="me-1 flex-grow-1">
      <p class="mb-1">¡Recuerda que tu acceso gratuito es válido por tiempo limitado!</p>
      Termina en
      <span class="w-bold">
        {{ time.d }}d
      </span>
      :
      <span class="w-bold">
        {{ time.h }}h
      </span>
      :
      <span class="w-bold">
        {{ time.m }}m
      </span>
      :
      <span class="w-bold">
        {{ time.s }}s
      </span>
    </div>
    <button @click="toggle = false" class="c-link c-link--white-full fs-18">
      <Icon icon="ci:close-big" />
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      toggle: true,

      localTimer: 0,
      time: {
        d: 0,
        h: 0,
        m: 0,
        s: 0,
      },
      intervalTimer: 0,
    };
  },
  props: ['end'],
  watch: {
    localTimer() {
      if (this.localTimer > 0) {
        this.time.s = Math.trunc(this.localTimer % 60);
        this.time.m = Math.trunc((this.localTimer / 60) % 60);
        this.time.h = Math.trunc(((this.localTimer / 60) / 60) % 24);
        this.time.d = Math.trunc((((this.localTimer / 60) / 60) / 24));
      } else {
        this.finishTimer();
      }
    },
  },
  mounted() {
    this.initTimer();
  },
  methods: {
    initTimer() {
      const expiredDate = new Date(this.end);
      const currentDate = new Date();

      if (expiredDate > currentDate) {
        this.localTimer = Math.abs(expiredDate - currentDate) / 1000;

        if (this.localTimer > 0) {
          this.intervalTimer = window.setInterval(() => {
            this.localTimer -= 1;
          }, 1000);
        } else {
          this.finishTimer();
        }
      } else {
        this.localTimer = 0;

        this.finishTimer();
      }
    },
    finishTimer() {
      window.clearInterval(this.intervalTimer);

      // window.location.href = '/cursos';
    },
  },
};
</script>
